<div class="content nav">
	<div class="content-wrap">
	<hhsg-message-bar [messages]="messages" [visibilityTimeout]="5" [isError]="hasErrorMessages"></hhsg-message-bar>
	<hhsg-page-header headerText="Notification Summary" subHeaderText="" [showBreadCrumb]="showBreadCrumb" [displayDivider]="false" class="admin-header">
		<div header-buttons class="nav-buttons">
			<hhsg-shared-ellipses-control #ellipsesMenu [ellipsesMenuItems]="ellipsesMenuItems" (ellipsesButtonClicked)="onEllipsisButtonClicked($event)"></hhsg-shared-ellipses-control>
		</div>
	</hhsg-page-header>
		<div class="content-inner mx-0">
			<form [formGroup]="form">
				<div class="notify-tab notify-sum nav">
					<div class="pt-1 noti-cont d-flex h-46">
						<input formControlName="selectAllcheckbox" *ngIf="notifications" type="checkbox" class="ml-2" [checked]="isSelectAll" (change)="selectAll();">
						<span class="mr-2 hide"><span class="material-symbols-outlined">more_vert</span></span>
					</div>
					<ul class="notificationList">
						<li class="noti-cont tablinks item" [id]="generateNotificationId(notification.notificationId)" *ngFor="let notification of notifications" [ngClass]="notification.notificationId==selectedNotification.notificationId?'selected':''">
							<input formControlName="selectCheckBox" type="checkbox"  (change)="notificationSelected(notification.notificationId)" [checked]="notification.isSelected">
							<div class="item-notify pr-1" (click)="onSelect(notification.notificationId)">
								<span class="noti-tit" [ngClass]="notification.isRead?'':'unread'">
									<span *ngIf="notification.isHighPriority" class="pl-0 text-red1 text-bold"> !</span>
									{{ notification.name }}</span>
								<div class="row mx-0">
									<span class="noti-sub" [ngClass]="notification.isRead?'':'unread'">
										{{convertMessage(notification.message)}}
									</span>
									<span class="noti-time">{{notification.notificationCreatedDate | date:getDateFormat(notification.notificationCreatedDate)}}</span>
								</div>
							</div>
						</li>
					</ul>
					<div class="unread-notification1 d-flex" *ngIf="!notifications">
						<span class="material-symbols-outlined">mark_email_read</span>
						<span class="blue-text font-16 unread" >No Notifications</span>
					</div>
				</div>
				<div class="richtext-placeholder h-46">
				</div>
				<div class="unread-notification2 d-flex" *ngIf="!notifications">
					<span class="material-symbols-outlined">mark_email_read</span>
				</div>
				<div *ngIf="selectedNotification" class="tabcontent pt-2 nav">
					<h3>{{selectedNotification.name}}</h3>
					<h5>From: {{selectedNotification.notificationFrom}}</h5>
					<h5>To: {{selectedNotification.userName}}</h5>
					<hr>
					<dx-html-editor  [value]="selectedNotification.message" [readOnly]="true">
                    </dx-html-editor>
				</div>
			</form>
		</div>
	</div>
</div>

<hhsg-shared-modal [(isActive)]="confirmDelete" (acceptEvent)="deleteNotifications()"
    (rejectEvent)="confirmDelete = false" [disableFooter]="false" [disableHeader]="true" type="small" acceptText="Yes"
    rejectText="No">
    <div role="body">
        Are you sure you want to delete this Notification(s)?
    </div>
</hhsg-shared-modal>
